import styled from 'styled-components';

import { Grid, IconExternal, spaceMixin } from '@zillow/constellation';

export const StyledCompsSummaryContainer = styled.div`
    text-align: left;
    margin-right: ${spaceMixin('xs')};
`;

export const StyledIconExternal = styled(IconExternal)`
    margin-left: ${spaceMixin('xs')};
`;

export const StyledRelativeGrid = styled(Grid)`
    position: relative;
    height: 125px;
`;
